export const ru = {
    add_bonus_card: 'Добавить карту лояльности',
    number: 'Номер',
    card: 'Карта',
    number_placeholder: 'Укажите номер карты',
};
